require('./Button_WatchOnline.scss');
require('../../Icon/Icon.scss');
require('../../Icon/_Play/_Size/Icon_Play_Size_S.scss');
require('../../Icon/_Play/_Size/Icon_Play_Size_M.scss');
require('../../Icon/_Play/_Size/Icon_Play_Size_L.scss');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Button = require('app/www/components/blocks/Button/Button');
const ButtonWrapper = require('app/www/components/blocks/ButtonWrapper/ButtonWrapper');
const Global = require('app/www/components/blocks/Global/Global');
const Ua = require('app/www/components/blocks/Ua/Ua');

class Button_WatchOnline extends React.PureComponent {

    constructor(props) {
        super(props);

        this._showButton = Global.isRussia && !Ua.isOldOpera && !Ua.isOldIE;
    }

    render() {
        if (!this._showButton) {
            return null;
        }

        const {
            i18n,
            fromBlock,
            children,
            ottSelection,
        } = this.props;

        const buttonProps = Object.assign({}, this.props, {
            attrs: {
                target: '_blank',
            },
            children: children || i18n.get('button.watchOnline'),
        });

        return (
            <ButtonWrapper>
                <Button
                    url={Global.getHdContentUrl(ottSelection.contentGroupUuid, fromBlock)}
                    ref={ref => (this.button = ref)}
                    {...buttonProps}
                />
            </ButtonWrapper>
        );
    }
}

Button_WatchOnline.propTypes = {
    mods: Button.propTypes.mods,
    fromBlock: PropTypes.string,
    ottSelection: PropTypes.shape({
        selectionId: PropTypes.number,
        contentGroupUuid: PropTypes.string,
    }),
};

module.exports = withI18n(Button_WatchOnline);
